import { css, jsx } from "@emotion/react";

export const HEADER_HEIGHT = `56px`;
export const BOTTOM_BAR_HEIGHT = `60px`;
export const BAR_WIDTH = "300px";
export const RIGHTBAR_WIDTH = "300px";

export const MEDIUM_WIDTH = `750px`;
export const LARGE_WIDTH = `1250px`;
export const MOBILE_WIDTH = `650px`;
export const TABLET_WIDTH = `1100px`;
export const BREAK_LOGIN = `900px`;

export const flex = css`
  display: flex;
  align-items: center;
`;

export const notSelect = css`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
